export default "__VITE_ASSET___rNYqURD__"